import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import homeBg from '@/assets/images/home-bg.jpg'

export const BgGrad = styled(Box)({
  backgroundImage: `url(${homeBg})`,
  backgroundColor: '#051d40',
  backgroundPosition: '0 0',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  minHeight: '100vh'
});
